import React from "react";
import Header from "@/components/shared/Header";
import { useLocation, useNavigate } from "react-router-dom";
import Details from "@/components/history/Details";
import TraceabilityHistory from "@/components/history/TraceabilityHistory";

export default function TrackingDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();


  return (
    <div className="flex flex-column gap-4">
      <Header title="History Details" onBack={() => navigate(-1)} />
      <Details item={state} />

      <TraceabilityHistory item={state} />
    </div>
  );
}
